import { Component } from '@angular/core';

@Component({
  selector: 'app-refund-return',
  imports: [],
  templateUrl: './refund-return.component.html',
  styleUrl: './refund-return.component.scss'
})
export class RefundReturnComponent {

}
